import React from "react";
import "./SaveAllButton.css"; // We will create this CSS file next
import { lang } from "../lang"; // For the button text

function SaveAllButton({
  onClick,
  hasUnsavedChanges,
  animationType = "pulse", // 'pulse' or 'border-chase' or 'none'
  // 'isActuallySaved' could be another prop if we want to show a temporary "Saved!" state
  // For now, hasUnsavedChanges = false implies it's "saved" or "in sync"
}) {
  let buttonClasses = "save-all-button-component"; // Base class

  if (hasUnsavedChanges) {
    buttonClasses += " unsaved-changes";
    if (animationType === "pulse") {
      buttonClasses += " animate-pulse";
    } else if (animationType === "border-chase") {
      buttonClasses += " animate-border-chase";
    }
    // No animation class added if animationType is 'none' or unrecognized
  } else {
    buttonClasses += " saved-changes"; // Indicates data is in sync with last download
  }

  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      title={
        hasUnsavedChanges
          ? "Save all data to a file (changes pending)"
          : "Save all data to a file (no new changes detected since last save-to-file)"
      }
    >
      {lang.drawer.saveAll} {/* "Save All" text from lang file */}
    </button>
  );
}

export default SaveAllButton;
